import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import dataOffer from './offers.js';
import assetsPath from '../../index.js';

/**
 * Offer text block molecule. Used in Odil interfaces.
 * @prop offer The offer variable. Is the offer name.
 * @prop context The interface who call this molecule.
 *
 */
@customElement('nn-offers-text-block')
export class OffersTextBlock extends LitElement {
  static styles = css`
    .listing-in-column,
    .listing-in-row {
      align-items: stretch;
      box-sizing: border-box;
      display: flex;
      flex-wrap: wrap;
      font-size: var(--base, 16px);
      height: auto;
      gap: 4px;
      padding: 8px;
      justify-content: space-between;
    }
    .listing-in-column {
      flex-direction: column;
    }
    .listing-in-row {
      flex-direction: row;
    }

    .listing-in-column .icon-inline.multiple {
      margin-bottom: 32px;
      position: relative;
    }
    .listing-in-column .icon-inline.multiple:after {
      background: var(--nn-black-24, #d6d6d6);
      content: '';
      display: block;
      height: 1px;
      margin: 0 auto;
      width: 55px;
      position: absolute;
      bottom: -16px;
      left: 0;
      right: 0;
    }
    .listing-in-column .icon-inline.multiple:last-child {
      margin: 0;
    }
    .listing-in-column .icon-inline.multiple:last-child:after {
      display: none;
    }
    .nn-separator {
      margin: 0 0 15px 80px;
      width: 55px;
      height: 0px;
      border: 1px solid var(--nn-black-24, #d6d6d6);
    }
  `;

  @property({ type: String }) offer = 'SAT_VITAL';

  @property({ type: String }) context = 'nordnet';

  render() {
    const itemTemplates: any = [];
    const offer = JSON.parse(
      JSON.stringify(dataOffer).replace(/<prefixPath>/g, assetsPath)
    );
    offer.forEach((element: any) => {
      if (element.offer === this.offer) {
        element.children.forEach((child: any) => {
          let content = child.contentOdil;
          if (this.context === 'nordnet') {
            content = child.contentNordnet;
          } else {
            content = child.contentOdil;
          }
          itemTemplates.push(html` <nn-card-offer-text
            .title="${child.title}"
            customizedClass="${child.customizedClass}"
            icon="${child.icon}"
            content="${content}"
          >
          </nn-card-offer-text>`);
          return child;
        });
      }
      return element;
    });

    if (this.context === 'nordnet') {
      return html` <div class="listing-in-row">${itemTemplates}</div>`;
    }

    return html` <div class="listing-in-row">${itemTemplates}</div>`;
  }
}
